module.exports = __webpack_public_path__ + "img/indexbg.1ae76b97.jpg";